import type { SourceDefinition } from '../types';

export const config = {
  id: 'geo',
  kind: 'route',
  url: '/api/geo',
  preload: 'fetch',
} satisfies SourceDefinition;
